import { makeStyles } from "@mui/styles";
import { Dialog, DialogContent, Box, Typography, CircularProgress } from "@mui/material";
import { customTheme as theme } from "../../../theme/customTheme";
import '../../../App.css'
import { useDispatch, useSelector } from "react-redux";
import { setAssetState } from "../../../redux/assetSlice";
import "@fontsource/rubik";
import { useState } from "react";

const useStyles = makeStyles((theme) => ({
    videoContainer: {
        position: 'relative',
        paddingBottom: '56.25%', /* 16:9 */
        width: '100%',
        height: 0
      },
    iframe: {
        width: '100%',
        aspectRatio: '16 / 9',
        borderRadius: '10px',
        backgroundColor: '#000000'
      },
    checkerboard: {
        backgroundImage: `linear-gradient(45deg, rgba(153,153,153,0.88) 25%, transparent 25%),
                          linear-gradient(-45deg, rgba(153,153,153,0.88) 25%, transparent 25%),
                          linear-gradient(45deg, transparent 75%, rgba(153,153,153,0.88) 75%),
                          linear-gradient(-45deg, transparent 75%, rgba(153,153,153,0.88) 75%)`,
        backgroundSize: '20px 20px',
        backgroundPosition: '0 0, 0 10px, 10px -10px, -10px 0px',
        backgroundColor: 'rgba(204,204,204,0.88)'
      }
}));

export default function BrandboxMediaPreview(props) {
  const classes = useStyles();
  const { maxWidth, width, height } = props;
  const assetReducer = useSelector((state) => state.assetReducer);
  const dispatch = useDispatch();

  const url = assetReducer.preview_url;
  const fileType = assetReducer.preview_file_type;
  const [imgLoaded, setImgLoaded] = useState(false);

  const handleClose = () => {
    setImgLoaded(false);
    dispatch(setAssetState({ open_media_preview: false, preview_url: null, preview_file_type: null }));
  };

  return (
    <Dialog
      open={assetReducer.open_media_preview}
      onClose={handleClose}
      aria-labelledby="brandbox-media-preview-title"
      aria-describedby="brandbox-media-preview-description"
      slotProps={{
        backdrop: {
          sx: {
            backdropFilter: 'blur(2px)'
          }
        }
      }}
      PaperProps={{
        sx: {
          borderRadius: '5px',
          width: width ? width : { xs: '480px', sm: '640px', md: '720px', lg: '960px', xl: '1600px' },
          maxWidth: '1920px !important',
          height: '100%',
          backgroundColor: 'transparent',
          boxShadow: 'none'
        }
      }}
      {...props}
    >
      <DialogContent
        sx={{ padding: '0px' }}
        id="brandbox-media-preview-description"
      >
        <Box className='flex col' height='100%'>
          <Box className='flex row j-end' sx={{ backgroundColor: 'transparent' }}>
            <Typography
              onClick={handleClose}
              sx={{
                fontFamily: 'Rubik',
                textAlign: 'right',
                fontSize: { xs: '8px', md: '11px', xl: '14px' },
                color: '#000000',
                width: '60px',
                fontWeight: 700,
                marginTop: { xs: '10px', sm: '15px', md: '20px', lg: '20px', xl: '44px' },
                marginBottom: { xs: '10px', md: '14px', lg: '12px', xl: '24px' },
                cursor: 'pointer',
                backgroundColor: 'transparent'
              }}
            >
              Close X
            </Typography>
          </Box>

          {fileType === 'video' ? (
            <video className={classes.iframe} src={url} controls>
              <source src={url} type="video/mp4" />
              <source src={url} type="video/ogg" />
              <source src={url} type="video/quicktime" />
              <source src={url} type="video/webm" />
            </video>
          ) : fileType === 'image' ? (
            <Box height='90%' className={`${classes.iframe} ${classes.checkerboard}`} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative', px: { xs: 2, md: 4, xl: 6 } }}>
              {!imgLoaded && (
                <CircularProgress size={36} sx={{ position: 'absolute', color: '#555' }} />
              )}
              <img
                src={url}
                style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', filter: 'drop-shadow(0px 0px 6px rgba(0,0,0,0.35))', display: imgLoaded ? 'block' : 'none' }}
                onLoad={() => setImgLoaded(true)}
              />
            </Box>
          ) : fileType === 'audio' ? (
            <audio className={classes.iframe} src={url}>
              <source src={url} type="audio/ogg" />
              <source src={url} type="audio/mpeg" />
              <source src={url} type="audio/wav" />
            </audio>
          ) : fileType !== 'unknown' ? (
            <iframe className={classes.iframe} src={url}>
              <source src={url} type="video/mp4" />
              <source src={url} type="video/ogg" />
              <source src={url} type="video/quicktime" />
              <source src={url} type="video/webm" />
              <source src={url} type="audio/ogg" />
              <source src={url} type="audio/mpeg" />
              <source src={url} type="audio/wav" />
            </iframe>
          ) : null}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
